module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAyElEQVQokaXSMWoCQRjF8V9kUnsdvUM6L5DC1kYIapZEUREJRIRUKVPmEBYhRbocIxcwVYjBwllYlh0cyKvmDe8/3xtmLrZPzxJaYYANpk2BkAAfMYzre1zith5qNYAPFbDUBMtz8Bo3iTYF5il4hVECLHWHWR1exmo5msZDhGiKTLDUHD8tjHHARyb4hj8UAVcR7qCbAb9igUPALm528lufmKZ3zlbqh/3ixek6AddNg1LwF/oV30O7HvpX7Sr8ju8z+T0+S3MEXcgibemPp10AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Homepage_con.png
// module id = clUj
// module chunks = 1